import { gql } from '@apollo/client';

export const GET_COACH_PUBLIC_DETAILS = gql`
  query GetCoachPublicDetails($username: String!) {
    getCoachPublicDetails(username: $username) {
      id
      firstName
      lastName
      profilePic
      minimumNoticeTime
      timeZone
      coachTypes {
        coachType
      }
      servicePackages {
        id
        title
        sessionPrice
        sessionDuration
        sessionDescription
        bookingType
      }
      officeAddress
      officePhone
      calendar
      videoCallPlatform
      isProvideOnlineConsultations
      isProvideInPersonConsultations
      brandConfigurations {
        brandTag
        brandNameLogo
        logo
      }
    }
  }
`;

export const CREATE_COACH_MINIWEB_BOOKING = gql`
  mutation createBookingInCoachMiniWeb($coachMiniWebBooking: CoachMiniWebBookingInput!) {
    createBookingInCoachMiniWeb(coachMiniWebBooking: $coachMiniWebBooking) {
      id
      coachId
      clientId
      date
      duration
      meetingLink
      createdAt
      updatedAt
      clientPhone
      clientFirstName
      clientLastName
      clientEmail
      servicePackage {
        id
        title
        sessionPrice
        sessionDuration
        sessionDescription
        coachId
        bookingType
      }
      isAgreedToTerms
      isSubscribedToNewsletter
      referenceText
      referenceNote
    }
  }
`;

export const GET_AVAILABLE_TIMES = gql`
  query getAvailableTimes(
    $username: String!
    $date: Float!
    $month: Float!
    $year: Float!
    $duration: Float!
  ) {
    getAvailableTimes(
      username: $username
      date: $date
      month: $month
      year: $year
      duration: $duration
    ) {
      date
    }
  }
`;

export const GET_MINIWEB_COACH_AVAILABILITIES = gql`
  query GetCoachAvailabilitiesForMiniweb($username: String!) {
    findCoachAvailabilitiesForMiniweb(username: $username) {
      id
      startTime
      endTime
      dayOfWeek
    }
  }
`;

export const GET_MINIWEB_BOOKINGS_FOR_MONTH = gql`
  query GetBookingsByMonthForMiniweb($username: String!, $month: Float!, $year: Float!) {
    getBookedDatesPerMonthForMiniweb(username: $username, month: $month, year: $year) {
      date
    }
  }
`;

export const UPLOAD_REFERENCES_IN_MINIWEB_BOOKING = gql`
  mutation uploadClientReferenceFile(
    $clientEmail: String!
    $username: String!
    $fileName: String!
    $contentType: String!
  ) {
    uploadClientReferenceFile(
      uploadClientReferenceFile: {
        clientEmail: $clientEmail
        username: $username
        referenceFile: { fileName: $fileName, contentType: $contentType }
      }
    ) {
      key
      url
      fileName
      contentType
    }
  }
`;
